import { render, staticRenderFns } from "./AddDepartment.vue?vue&type=template&id=d48f292c&"
import script from "./AddDepartment.vue?vue&type=script&lang=js&"
export * from "./AddDepartment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports